/**
 * Configured options for the linkify plugin.
 */
export const linkifyOptions = {
  target: '_blank',
  defaultProtocol: 'https',
  validate: {
    url: (value) => {
      // Allow only HTTPS and no protocol - no protocol will be converted to HTTPS by defaultProtocol
      if (value.startsWith('https://')) return true;
      if (!/^[a-zA-Z]+:\/\//.test(value)) return true;
      return false;
    },
  },
}
